export const LOG_IN = "/login";
export const FORGOT = "/forgotpassword";
export const REGISTER = "/registeruser";
export const VERIFICATION = "/verification";
export const NOT_FOUND = "/not-found";

export const PROFILE = "/profile";

export const DASHBOARD = "/";
export const MASTERDATA = "/master-data";
export const VIEW_PROGRAMS = `${MASTERDATA}/viewprograms`;
export const VIEW_GUEST_LIST_PROGRAM = `${MASTERDATA}/viewguestlist`;
export const VIEW_ASSESSMENT = `${MASTERDATA}/viewassessment`;
export const ADD_RECIPE_COLLECTION = `${MASTERDATA}/addrecipecollection`;
export const ADD_RECIPE = `${MASTERDATA}/addrecipe`;
export const EDIT_RECIPE = `${MASTERDATA}/editrecipe`;
export const RECIPE_LIST = `${MASTERDATA}/recipelist`;
export const VIEW_RECIPE = `${MASTERDATA}/viewRecipe`;
export const VIEW_ACTIVITY = `${MASTERDATA}/viewactivity`;
export const ADD_ACTIVITY = `${MASTERDATA}/addactivity`;
export const EDIT_ACTIVITY = `${MASTERDATA}/editactivity`;
export const VIEW_INTERESTED_GUEST_LIST_ACTIVITY = `${MASTERDATA}/viewinterestedguestlist`;

export const CONTENT_MANAGEMENT = "/content-management";
export const ADD_VIDEO_PODCASTS = `${CONTENT_MANAGEMENT}/addvideopodcast`;
export const ADD_BLOG_ARTICLE = `${CONTENT_MANAGEMENT}/addblogarticle`;
export const VIEW_BLOG_ARTICLE = `${CONTENT_MANAGEMENT}/viewblogarticle`;
export const ADD_ANNOUNCEMENT = `${CONTENT_MANAGEMENT}/add-announcement`;
export const EDIT_ANNOUNCEMENT = `${CONTENT_MANAGEMENT}/edit-announcement`;

export const USER_MANAGEMENT = "/user-management";
export const ADD_USER = `${USER_MANAGEMENT}/adduser`;
export const EDIT_USER = `${USER_MANAGEMENT}/guestuser/edituser`;
export const VIEW_USER = `${USER_MANAGEMENT}/guestuser/viewuser`;
export const DOWNLOAD_EDIT_USER = `${USER_MANAGEMENT}/downloads/edituser`;
export const DOWNLOAD_VIEW_USER = `${USER_MANAGEMENT}/downloads/viewuser`;
export const ADD_MEMBER = `${USER_MANAGEMENT}/addmember`;
export const VIEW_MEMBER = `${USER_MANAGEMENT}/viewmember`;
export const TEAM_LIST = `${USER_MANAGEMENT}/teamlist`;

export const USER_MANUAL = "/user-manual";
export const VIEW_USER_MANUAL = "/user-manual/view"

export const ANALYTICAL_REPORT = "/analytical-report";


export const EVENT = "/event";

export const REPORTS = "/reports";
export const VIEW_PROGRAM_FEEDBACK =   `${REPORTS}/viewProgramFeedback`;
export const VIEW_GUEST_DINACHARYA =   `${REPORTS}/viewGuestDinacharya`;





export const SOCIAL_SHARING = "/socialsharing";
export const MAKE_ANNOUNCEMENT = `${SOCIAL_SHARING}/makeannouncement`;
export const ADD_NEW_GROUP = `${SOCIAL_SHARING}/addnewgroup`;


